export default "__VITE_ASSET__3L_4H098__"